import { AttributablePay } from '@fora-monorepo/employer-my-pages-common/types';
import { swedishNumberFormatter } from '@fora-monorepo/string-utils';
import { capitalizeString } from '@foradevelopment/fora-ui';

import { MonthInfo, PayInputState } from './types';
import { MAX_NUMBER_OF_DIGITS_PAY_AMOUNT } from '../../../common/constants';

// TASK: 106138 - Remove this function and use i18n lib instead
export const formatMonthInfo = (month: number, year: number): MonthInfo => ({
  monthShort: capitalizeString(
    new Date(year, month - 1).toLocaleDateString('sv-SE', { month: 'short' }).replace('.', '')
  ),
  attributablePayMonth: `${year}${month.toString().padStart(2, '0')}`,
});

export const initAttrPayInput = (attrPay: AttributablePay, month: string) => {
  const amount = attrPay?.find(p => p.attributablePayMonth === month)?.attributablePayAmount;

  if (!amount) {
    return { amount: null, formatted: '' };
  }
  return { amount, formatted: swedishNumberFormatter(amount) };
};

export const inputOnChangeFormatPay = (value: string): PayInputState => {
  const digitsOnly = value.replace(/\D/g, '');
  if (digitsOnly === '') {
    return { amount: null, formatted: '' };
  }

  const slicedValue = digitsOnly.slice(0, MAX_NUMBER_OF_DIGITS_PAY_AMOUNT);

  const parsedNumber = Number(slicedValue);

  if (Number.isNaN(parsedNumber)) {
    return { amount: null, formatted: '' };
  }
  return { amount: parsedNumber, formatted: swedishNumberFormatter(parsedNumber) };
};

/** If there is previously reported attributable pay, check that the new attributable pay is not decreased */
export const isAttrPaySameOrLargerForDeceasedOrAgedIdividual = (
  attributablePay: AttributablePay,
  attributablePayReported?: AttributablePay | null
) => {
  if (!attributablePayReported) {
    return true;
  }
  return attributablePayReported.every(
    ({ attributablePayAmount: reportedPayAmount, attributablePayMonth: reportedPayMonth }) => {
      const newAttrPayPart = attributablePay.find(newAP => newAP.attributablePayMonth === reportedPayMonth);
      if (!newAttrPayPart || newAttrPayPart.attributablePayAmount < reportedPayAmount) {
        return false;
      }
      return true;
    }
  );
};
